// extracted by mini-css-extract-plugin
export default {"textM":"textM_textM__fcLoi"};